export const debounce =
  <T>(fn: Function, wait = 1000, time?: NodeJS.Timeout) =>
  (...args: T[]) => {
    clearTimeout(time);
    time = setTimeout(() => fn(...args), wait);
  };
